import { createSelector } from '@reduxjs/toolkit';
import { StateType } from '../../../types';
import { StateAuthType } from '../reducers/types';

export const getRegister = createSelector(
  (state: StateType) => state.auth,
  (auth: StateAuthType) => auth.register,
);

export const getCurrentPage = createSelector(getRegister, (register) => register.currentPage);

export const getIsLoading = createSelector(getRegister, (register) => register.loading);
